import script from "./idaasLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./idaasLogin.vue?vue&type=script&setup=true&lang=js"

import "./idaasLogin.vue?vue&type=style&index=0&id=96ffd664&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/idaas_web_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96ffd664"]])

export default __exports__